import { useCallback, useEffect, useRef } from 'react';

import useIntersectionObserver from '@pflegia/ui/hooks/use-intersection-observer';

import { useJobDetails } from '@shared/context/job-details.context';

const TIMEOUT_MS = 5_000;

export const usePausedJobModal = ({ enabled }: { enabled: boolean }) => {
  const elementRef = useRef<HTMLElement>(null);
  const { setShowPausedModal } = useJobDetails();

  const handleIntersection = useCallback<IntersectionObserverCallback>(
    (entries, observer) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setShowPausedModal(true);
          observer.disconnect();
          return;
        }
      }
    },
    [setShowPausedModal],
  );

  useIntersectionObserver({ callback: handleIntersection, condition: enabled, ref: elementRef, type: 'enter' });

  useEffect(() => {
    if (!enabled) return;
    const timeout = setTimeout(() => {
      setShowPausedModal(true);
    }, TIMEOUT_MS);
    return () => {
      clearTimeout(timeout);
    };
  }, [enabled, setShowPausedModal]);

  return { elementRef };
};
